import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { MfaType } from '../store/createAccountantOnboarding';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    customerId: string;
    authorizedUserId: string;
    answer: string;
    mfaType: MfaType;
}
export const useValidateMfa = (handleError: (errCode: number) => void) => useMutation(
  'useValidateMfa',
  async ({
    customerId, authorizedUserId, mfaType, answer,
  }: IProps) => {
    const { data } = await httpService.post(`/api/v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/validateMfa`, {
      answer,
      mfaType,
      resetPassword: true,
    });
    return data;
  },
  {
    onError: (e: IServerErrorResponse) => {
      const errorCode = e?.response?.data?.errors?.[0]?.code;
      handleError(errorCode);
    },
  },
);
